import * as React from 'react';
import { usePreloaderStore } from './stores';
import './preloader.css';

// Как у пользовательского фронта (index.html .app-loader/.fade-out):
// плавное появление/затухание + минимальное время показа, чтобы лоадер не мелькал на быстрых запросах.
const FADE_MS = 500;
const MIN_SHOW_MS = 1000;

// Брендовый лоадер (монетка «S») — общий оверлей действий админки.
export default function Preloader() {
    const isActive = usePreloaderStore((state) => state.isActive);
    const [mounted, setMounted] = React.useState(false);
    const [shown, setShown] = React.useState(false);
    const shownAtRef = React.useRef(0);

    React.useEffect(() => {
        if (isActive) {
            setMounted(true);
            shownAtRef.current = Date.now();
            // двойной rAF — чтобы transition отработал от opacity 0 после монтирования
            let raf2;
            const raf1 = requestAnimationFrame(() => { raf2 = requestAnimationFrame(() => setShown(true)); });
            return () => { cancelAnimationFrame(raf1); if (raf2) cancelAnimationFrame(raf2); };
        }
        const elapsed = Date.now() - shownAtRef.current;
        const fadeTimer = setTimeout(() => setShown(false), Math.max(0, MIN_SHOW_MS - elapsed));
        return () => clearTimeout(fadeTimer);
    }, [isActive]);

    React.useEffect(() => {
        if (shown || !mounted) return undefined;
        const unmountTimer = setTimeout(() => setMounted(false), FADE_MS);
        return () => clearTimeout(unmountTimer);
    }, [shown, mounted]);

    if (!mounted) return null;

    return (
        <div className={`app-loader${shown ? ' show' : ''}`}>
            <div className="app-loader-coin">
                <span className="app-loader-pulse" />
                <span className="app-loader-pulse delay" />
                <span className="app-loader-orbit" />
                <span className="app-loader-core">S</span>
            </div>
            <div className="app-loader-text">
                Загрузка<span className="d">.</span><span className="d">.</span><span className="d">.</span>
            </div>
        </div>
    );
}
